import { useEffect } from "react"
import ImageSectionItem from "./common/ImageSectionItem"
import SeparatorLine from "./common/SeparatorLine"
import TextItem from "./common/TextItem"

const Certifications = () => {

    useEffect(() => {
        document.title = 'Séneca - Certificaciones'
        window.scrollTo(0, 0)
    }, [])

    return (

        <main className='generic-main'>

            <section className="margin-top" />

            <TextItem
                title="CERTIFICACIONES"
                textArray={[
                    "<p className='legal-text'>Desde <strong>Spica S.L.</strong> estamos comprometidos con todos nuestros clientes y con el medioambiente, por ello contamos con las certificaciones oportunas en materia de calidad, medio ambiente y seguridad.</p>"
                ]}
            />

            <SeparatorLine />

            <ImageSectionItem
                imagePosition="before"
                layout="row"
                imageURL="/images/certifications/SGC.png"
                title="Sistema de Gestión de la Calidad"
                textArray={[
                    "<p class='middle-section-label'>UNE-EN ISO 9001</p>",
                    "<article class='flex'><a href='/documents/ISO-9001-2021.pdf' target='_blank' rel='noopener noreferrer' className='send-button fit mar-30'>DESCARGAR CERTIFICADO</a></article>"
                ]}
            modern="true"
            />

            <SeparatorLine />

            <ImageSectionItem
                imagePosition="before"
                layout="row"
                imageURL="/images/certifications/SGM.png"
                title="Sistema de Gestión Medioambiental"
                textArray={[
                    "<p class='middle-section-label'>UNE-EN ISO 14001</p>",
                    "<article class='flex'><a href='/documents/ISO-14001-2024.pdf' target='_blank' rel='noopener noreferrer' className='send-button fit mar-30'>DESCARGAR CERTIFICADO</a></article>"
                ]}
            modern="true"
            />

            <ImageSectionItem
                imagePosition="before"
                layout="row"
                imageURL="/images/certifications/ENS.png"
                title="Esquema Nacional de Seguridad"
                textArray={[
                    "<p class='middle-section-label'>RD 311/2022</p>",
                    "<article class='flex'><a href='/documents/ENS-ALTA.pdf' target='_blank' rel='noopener noreferrer' className='send-button fit mar-30'>DESCARGAR CERTIFICADO</a></article>"
                ]}
            modern="true"
            />


        </main>
    )

}

export default Certifications